// ================================
// ROUTE GUARDS
// ================================
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

export function CustomerRoute({ children }) {
  const { user, role, loading } = useAuth();
  if (loading) return <div className="loading">Loading...</div>;
  if (!user || role !== 'customer') return <Navigate to="/login" />;
  return children;
}

export function AdminRoute({ children }) {
  const { user, role, loading } = useAuth();
  if (loading) return <div className="loading">Loading...</div>;
  if (!user || role !== 'admin') return <Navigate to="/admin" />;
  return children;
}

export function DriverRoute({ children }) {
  const { user, role, loading } = useAuth();
  if (loading) return <div className="loading">Loading...</div>;
  if (!user || role !== 'driver') return <Navigate to="/driver" />;
  return children;
}

export function StaffRoute({ children }) {
  const { user, role, loading } = useAuth();
  if (loading) return <div className="loading">Loading...</div>;
  if (!user || role !== 'staff') return <Navigate to="/staff" />;
  return children;
}

export default CustomerRoute;
